import React, { Fragment, useState, useEffect } from "react";
import io from "socket.io-client";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { getDiscussion, endDiscussion } from "../../actions/discussion";
import { chatMessage, deleteChatMessage } from "../../actions/stream";
import { getGifs, getGifsSearch } from "../../actions/gif";
import { getProfileById } from "../../actions/profile";

import LoggedInNav from "../layout/IME/LoggedInNav";
import DiscussionChat from "../layout/Innovators/DiscussionChat";
import DiscussionDualVideos from "../layout/Innovators/DiscussionDualVideos";
import DiscussionQuadVideos from "../layout/Innovators/DiscussionQuadVideos";
import DiscussionGroupVideos from "../layout/Innovators/DiscussionGroupVideos";
// import ReportUser from "../layout/IME/ReportUser";
import DiscussionInfo from "../layout/Innovators/DiscussionInfo";
import TwoParticipants from "../layout/Innovators/TwoParticipants";
import EightParticipants from "../layout/Innovators/EightParticipants";
import FourParticipants from "../layout/Innovators/FourParticipants";
import DiscussionParticipants from "../layout/Innovators/DiscussionParticipants";
import EndDiscussion from "../layout/Innovators/EndDiscussion";
import GreenSpinner from "../../img/Green_Spinner.gif";
import Offline from "../layout/IME/Offline";

let socket;

const DiscussionLiveStream = ({
  match,
  auth: { user, channelid, jobtitle, location, verified },
  profile: { profile },
  discussion: { live_discussion },
  getDiscussion,
  endDiscussion,
  getProfileById,
  chatMessage,
  deleteChatMessage,
  getGifs,
  getGifsSearch,
  gif: { gifs, loading },
  isAuthenticated,
}) => {
  const ENDPOINT = "localhost:5000";

  const [participant, setParticipant] = useState({
    channelid: user.channelid,
    avatar: user.avatar,
    firstname: user.firstname,
    lastname: user.lastname,
  });
  const [count, setCount] = useState(0);
  const [participantOneCountDown, setParticipantOneCount] = useState(0);
  const [participantTwoCountDown, setParticipantTwoCount] = useState(0);
  const [discussions, setDiscussions] = useState([]);
  const [endLiveDiscussion, setEndDiscussion] = useState(false);
  const [showGIFs, setshowGIFs] = useState(false);
  const [gifSearch, setGifSearch] = useState(false);
  const [text, setText] = useState("");
  const [foundGif, setGif] = useState("");
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [room, setRoom] = useState(match.params.channelid);
  const [imeBotAvi, setimebotavi] = useState("Innovate_Me_logo_green.png");
  const [showChat, setShowChat] = useState(true);
  const [discussion, setDiscussion] = useState({
    duo: true,
    panel: false,
    group: false,
  });

  const deleteMessage = (id, message) => {
    deleteChatMessage(match.params.channelid, message);
    const removeIndex = messages
      .map((deletedMessage) => deletedMessage.messageid)
      .indexOf(id);

    messages.splice(removeIndex, 1);

    setMessages([...messages]);
  };

  useEffect(() => {
    getProfileById(match.params.channelid);
    getDiscussion(match.params.channelid);
    getGifs();
  }, [getProfileById, getDiscussion, match.params.channelid, user]);

  useEffect(() => {
    if (user) {
      socket = io(ENDPOINT);

      socket.on("getParticipants", (participants) => {
        setDiscussions([...participants]);
      });

      socket.on("timer", (countDown) => {
        setCount(countDown);
      });

      socket.on("participantOneCount", (participantOneCountDown) => {
        setParticipantOneCount(participantOneCountDown);
      });

      socket.on("participantTwoCount", (participantTwoCountDown) => {
        setParticipantTwoCount(participantTwoCountDown);
      });

      socket.on("roomUsers", (room, users) => {
        console.log(room, users);
      });

      socket.emit("joinRoom", {
        imebotavi: imeBotAvi,
        channelid: user.channelid,
        avatar: user.avatar,
        firstname: user.firstname,
        lastname: user.lastname,
        room: match.params.channelid,
      });
    }

    return () => {
      if (socket) {
        socket.emit("leave");

        socket.on("roomUsers", (users) => {
          // setViewerCount([...users.users]);
        });

        socket.disconnect();

        socket.off();
      }
    };
  }, [ENDPOINT, match.params.channelid, user]);

  useEffect(() => {
    socket.on("message", (message) => {
      setMessages([...messages, message]);
    });
  }, [messages]);

  const sendMessage = (e) => {
    e.preventDefault();
    if (message || foundGif !== "") {
      chatMessage(match.params.channelid, message, foundGif);
      socket.emit(
        "chatMessage",
        message,
        foundGif,
        user.firstname,
        user.lastname,
        user.avatar,
        room
      );
      setMessage("");
      setGif("");
      setshowGIFs(false);
    }
  };

  useEffect(() => {
    socket.on("sendParticipants", (participants) => {
      setDiscussions(participants);
    });
  }, [discussions]);

  const removeParticipant = (channelid) => {
    setDiscussions(discussions.filter((item) => item.channelid !== channelid));
    socket.emit("removeParticipant", participant);
  };

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  // if (
  //   isAuthenticated &&
  //   user.channelid === profile.channelid &&
  //   !live_discussion.live
  // ) {
  //   return <Redirect to={`/${user.channelid}/create_discussion`} />;
  // }

  return (
    <Fragment>
      {endLiveDiscussion && (
        <EndDiscussion
          user={user}
          endDiscussion={endDiscussion}
          setEndDiscussion={setEndDiscussion}
        />
      )}
      <LoggedInNav />
      <section className={showChat ? "flex-only-alt" : "flex-no-chat"}>
        <DiscussionParticipants
          discussions={discussions}
          removeParticipant={removeParticipant}
          setParticipant={setParticipant}
        />
        <div className="main-stream-content">
          <div className="video-chat">
            {live_discussion &&
              live_discussion.live &&
              live_discussion.discussiontype === "1-on-1" && (
                <DiscussionDualVideos
                  discussions={discussions}
                  showChat={showChat}
                />
              )}
            {live_discussion &&
              live_discussion.live &&
              live_discussion.discussiontype === "4-person" && (
                <DiscussionQuadVideos
                  discussions={discussions}
                  showChat={showChat}
                />
              )}
            {live_discussion &&
              live_discussion.live &&
              live_discussion.discussiontype === "group" && (
                <DiscussionGroupVideos
                  discussions={discussions}
                  showChat={showChat}
                />
              )}
            {live_discussion && !live_discussion.live && (
              <Offline profile={profile} showChat={showChat} />
            )}
            {!showChat && (
              <div className="showchaticon" onClick={() => setShowChat(true)}>
                <i className="far fa-comment fa-2x green"></i>
              </div>
            )}
          </div>
          {live_discussion &&
          live_discussion.live &&
          discussions &&
          discussions.length > 1 ? (
            <div className="discussion-time-container">
              <p className="remaining-time white">{participantOneCountDown}</p>
              <p className="remaining-time white">
                <span className="remaining-time-text green">
                  Time Remaining:
                </span>
                {count}
              </p>
              <p className="remaining-time white">{participantTwoCountDown}</p>
            </div>
          ) : (
            <div>
              {live_discussion && live_discussion.live && (
                <div className="discussion-time-container">
                  <p className="remaining-time white"></p>
                  <p className="remaining-time white">
                    <span className="remaining-time-text-alt white">
                      <img
                        className="mini-spinner"
                        src={GreenSpinner}
                        alt="spinner"
                      />
                      Awaiting Participants...
                    </span>
                  </p>
                  <p className="remaining-time white"></p>
                </div>
              )}
            </div>
          )}
          <div
            onClick={() => {
              setEndDiscussion(true);
            }}
            className={
              showChat
                ? "submit-changes-discussion-alt"
                : "submit-changes-discussion-no-chat"
            }
          >
            <button className="submit-changes-button background-green">
              End Discussion
            </button>
          </div>
          {discussions &&
          discussions.length > 0 &&
          live_discussion &&
          live_discussion.live &&
          live_discussion.discussiontype === "1-on-1" ? (
            <div className="stream-section-container">
              <div className="padding-container">
                <div className="title-container-info">
                  <div className="border-alt green">
                    <p className="online-title-alt green">Up Next</p>
                  </div>
                </div>
                <TwoParticipants discussions={discussions} />
              </div>
            </div>
          ) : (
            <div>
              {live_discussion &&
                live_discussion.discussiontype === "1-on-1" && (
                  <div className="green bold large-font empty-content-alt mx-25">
                    No Participants
                  </div>
                )}
            </div>
          )}
          {discussion.panel &&
          live_discussion &&
          live_discussion.live &&
          live_discussion.discussiontype === "4-person" ? (
            <div className="stream-section-container">
              <div className="padding-container">
                <div className="title-container-info">
                  <div className="border-alt green">
                    <p className="online-title-alt green">Up Next</p>
                  </div>
                </div>
                <FourParticipants />
              </div>
            </div>
          ) : (
            <div>
              {live_discussion &&
                live_discussion.discussiontype === "4-person" && (
                  <div className="green bold large-font empty-content-alt mx-25">
                    No Participants
                  </div>
                )}
            </div>
          )}
          {discussion.group &&
          live_discussion &&
          live_discussion.live &&
          live_discussion.discussiontype === "group" ? (
            <div className="stream-section-container">
              <div className="padding-container">
                <div className="title-container-info">
                  <div className="border-alt green">
                    <p className="online-title-alt green">Up Next</p>
                  </div>
                </div>
                <EightParticipants />
              </div>
            </div>
          ) : (
            <div>
              {live_discussion &&
                live_discussion.discussiontype === "group" && (
                  <div className="green bold large-font empty-content-alt mx-25">
                    No Participants
                  </div>
                )}
            </div>
          )}
          <DiscussionInfo profile={profile} live_discussion={live_discussion} />
          <div className="margin-top"></div>
        </div>
        {showChat && (
          <DiscussionChat
            messages={messages}
            message={message}
            setMessage={setMessage}
            deleteMessage={deleteMessage}
            gifs={gifs}
            setGif={setGif}
            foundGif={foundGif}
            showGIFs={showGIFs}
            setshowGIFs={setshowGIFs}
            getGifsSearch={getGifsSearch}
            gifSearch={gifSearch}
            setGifSearch={setGifSearch}
            sendMessage={sendMessage}
            text={text}
            setText={setText}
            setShowChat={setShowChat}
          />
        )}
      </section>
    </Fragment>
  );
};

DiscussionLiveStream.propTypes = {
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  discussion: PropTypes.object.isRequired,
  getDiscussion: PropTypes.func.isRequired,
  endDiscussion: PropTypes.func.isRequired,
  chatMessage: PropTypes.func.isRequired,
  deleteChatMessage: PropTypes.func.isRequired,
  getGifs: PropTypes.func.isRequired,
  getProfileById: PropTypes.func.isRequired,
  getGifsSearch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile,
  discussion: state.discussion,
  gif: state.gif,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  getProfileById,
  getDiscussion,
  endDiscussion,
  chatMessage,
  deleteChatMessage,
  getGifs,
  getGifsSearch,
})(DiscussionLiveStream);
